import { css } from "@emotion/react";
import { TiptapMenuCSS } from "./tiptapMenuStyles";

const GlobalStyle = css`
  /* @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"); */
  /* @import url("./fonts/SFProDisplay-Regular.ttf"); */
  /* @import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap"); */

  * {
    box-sizing: border-box;
    font-family: "Source Sans Pro", sans-serif;
    outline: none;
    white-space: pre-wrap;
    overflow-wrap: break-word;
  }

  html,
  body {
    overflow: hidden;
    margin: 0px;
    padding: 0px;
  }

  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  *::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: rgba(168, 168, 168, 0.3);
    border-radius: 5px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: rgba(168, 168, 168, 0.7);
  }

  /* @font-face {
    font-family: "SF Pro Display";
    font-weight: normal;
    src: local("SF Pro Display"),
      url("./fonts/SFProDisplay-Regular.ttf") format("truetype");
  }

  @font-face {
    font-family: "SF Pro Display";
    font-weight: bold;
    src: local("SF Pro Display Bold"),
      url("./fonts/SFProDisplay-Bold.ttf") format("truetype");
  } */

  .Toastify__toast-body {
    z-index: 999991;
  }

  .Toastify__progress-bar--default {
    color: #fb972e;
    background: #fb972e;
  }

  .border-hover {
    :focus {
      box-shadow: 0px 0px 6px #fb972e4d;
      border: 1px solid #fb972e !important;
    }
  }

  .MuiPopover-paper {
    z-index: 9999 !important;
  }

  .css-trqve8-Wrapper {
    z-index: 99 !important;
  }

  .css-qlgo61:focus,
  .css-qlgo61[data-focus] {
    box-shadow: none !important;
  }

  ${TiptapMenuCSS}

  .react-component, .react-renderer {
    display: flex;
  }

  .ProseMirror a[href] {
    cursor: text;
  }

  /* .ProseMirror a[href]::selection {
    background-color: rgb(251, 151, 46, 0.5);
  } */

  .MuiPopover-root {
    z-index: 9999999 !important;
  }

  .MuiIconButton-root:hover {
    color: #fb972e;
    background-color: #fb972e20 !important;
    font-weight: 600;
    border-radius: 4px;
  }

  .MuiPickersDay-daySelected {
    border: 1px solid #fb972e !important;
    border-radius: 2px !important;
    background-color: #fff !important;
    color: #fb972e !important;
  }

  .MuiIconButton-root {
    border-radius: 0 !important;
  }

  .MuiPickersDay-current {
    color: #000 !important;
    background-color: #f0f0f0 !important;
    font-weight: 700 !important;
  }

  .cs--noop--italic {
    font-style: italic;
  }
`;

export default GlobalStyle;
